import React from "react";
import { FormikProps } from "formik";
import ICCheckbox from "../form/ICCheckbox";

interface IICFormikCheckBoxProps<T> extends FormikProps<T> {
  name: keyof T;
  label: string;
  checkedValue: string | number | boolean;
  unCheckedValue: string | number | boolean;
  labelClassName?: string;
  disabled?: boolean;
  required?: boolean;
}

const ICFormikCheckBox = <T extends Object>(
  props: IICFormikCheckBoxProps<T>
) => {
  const { values, setFieldValue } = props;
  const {
    name,
    label,
    labelClassName,
    checkedValue,
    unCheckedValue,
    disabled,
    required,
  } = props;
  const fieldName = props.name as string;
  return (
    <ICCheckbox
      label={label}
      labelClassName={labelClassName}
      disabled={disabled}
      required={required}
      onChange={(value) =>
        setFieldValue(fieldName, value ? checkedValue : unCheckedValue)
      }
      checked={values[name] === checkedValue}
    />
  );
};

export default ICFormikCheckBox;
